import { useScriptInjection } from '@/hooks/useScriptInjection';

/**
 * Component that handles dynamic script injection from admin settings.
 * This component doesn't render anything visible - it only manages script injection.
 */
const ScriptInjector = () => {
  useScriptInjection();
  return null;
};

export default ScriptInjector;
